import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { hasRequiredAddressParams } from './signup-address.store';
import { SignupResetService } from '../signup-reset.service';

/**
 * /signup needs the landing page's address hand-off (`?street=&city=&state=&zip=`, unit optional); without
 * every required param it goes back to the landing page to enter one. Not the app root: for a logged-out visitor
 * that's /login, and a new customer can't log in until their account is set up. Malformed values still pass
 * (→ waitlist).
 */
export const signupAddressGuard: CanActivateFn = route => {
  if (hasRequiredAddressParams(route.queryParamMap)) return true;
  inject(SignupResetService).exitToLanding();
  return false;
};
